(() => {
    // Block Name
    const blockName = 'hero-post';

    // Variables
    let method = 'front';
    if (document.querySelector('body') == null || document.querySelector('body').classList.contains('wp-admin')) {
        method = 'wp-admin';
    }
    let slider;
    // -- end

    // Custom methods

    const initBlock = function () {
        var $ = jQuery.noConflict();

        $(document).ready(function () {
            $('.js-select2-link').each(function () {
                let placeholder = $(this).data('select2-placeholder').length;
                if (placeholder > 1) {
                    $(this).select2({
                        placeholder: $(this).data('select2-placeholder')
                    })
                } else {
                    $(this).select2();
                }
            });

            $('.js-select2-link').on("select2:selecting", function (e) {
                window.location = e.params.args.data.id;
            });
        });
    };

    // Init blocks
    const initializeBlock = (block) => {
        if (block[0] !== undefined) block = block[0].querySelector(`.block-${blockName}`);
        if (block === false || block === null) return

        // Block Code Here

        initBlock();

        window.addEventListener('resize', initBlock);
    };

    // Get all blocks
    const getBlocks = () => {
        let blocks = document.querySelectorAll(`.block-${blockName}`);

        if (blocks.length > 0) {
            blocks.forEach((block) => {
                initializeBlock(block);
            });
        }
    };

    // Frontend
    document.addEventListener('DOMContentLoaded', getBlocks);

    // Acf Init
    window.addEventListener('load', (event) => {
        if (window.acf) {
            getBlocks();

            // Add update block action for ACF
            window.acf.addAction(`render_block_preview/type=${blockName}`, initializeBlock);
        }

    });

})();
